import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
    dateFilter,
    getDateFilterOption,
    getDateFilterOptionCustom,
} from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AppRoute from 'general/constants/AppRoute';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import DialogVoucherDetailView from '../DialogVoucherDetailView';
import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import VoucherListFilterView from './components/VoucherListFilterView';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import AppResource from 'general/constants/AppResource';
import DialogReleaseVoucherView from '../DialogReleaseVoucherView';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import PropTypes from 'prop-types';
import AppConfigs from 'general/constants/AppConfigs';
import CustomDateRangePicker2 from 'general/components/Others/CustomDateRangePicker2';
import ChargeHelper from 'features/Charge/chargeHelper';
import * as ExcelJS from 'exceljs';

VoucherListView.propTypes = {
    agencyId: PropTypes.string,
    showFullUI: PropTypes.bool,
    onRefresh: PropTypes.func,
    voucherBatchId: PropTypes.string,
    refreshVoucherList: PropTypes.bool,
    getVoucherBatchDetail: PropTypes.func,
};

const defaultColumnIds = [
    'VOUCHER_CODE',
    'BATCH_CODE',
    'USE_CODE',
    'DRIVER_NAME',
    'VIN_NUMBER',
    'VOUCHER_TYPE',
    'VOUCHER_AMOUNT',
    'USED_AMOUNT',
    'USED_QUANTITY',
    'TRANSACTIONS',
    'RELEASED_DATE',
    'EXPIRED_DATE',
    'STATUS',
    'CREATED_BY',
    'DATE',
];

function VoucherListView(props) {
    // ---- params ----
    const { agencyId, showFullUI = true, onRefresh, voucherBatchId, refreshVoucherList = false, getVoucherBatchDetail = () => { } } = props;
    const { t } = useTranslation();
    const router = useRouter();
    const { user, permissionList } = useSelector((state) => state.auth);
    const [operatorList, setOperatorList] = useState([]);
    const [filter, setFilter] = useState(AgencyHelper.Filter.voucherList);
    const [filterDropdown, setFilterDropdown] = useState(AgencyHelper.Filter.voucherList);
    const [voucherList, setVoucherList] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedVoucherBatch, setSelectedVoucherBatch] = useState(null);
    const [releaseVoucher, setReleaseVoucher] = useState([]);

    const app = useSelector((state) => state.app);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'VOUCHER_CODE',
                name: UIHelper.buildTableColumn('Mã voucher'),
                selector: (row) => row?.voucherId ? `VC${row?.voucherId?.toString().padStart(8, '0')}` : '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '120px',
                ignoreRowClick: true
            },
            {
                id: 'BATCH_CODE',
                name: UIHelper.buildTableColumn('Mã lô voucher'),
                width: '120px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : ''}>
                            <span onClick={() => {
                                Utils.openInNewTab(`${AppRoute.voucherBatchList}/${row?.voucherBatchId}`)
                            }} >
                                {row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : ''}
                            </span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
                omit: !!voucherBatchId,
            },
            {
                id: 'USE_CODE',
                name: UIHelper.buildTableColumn('Mã sử dụng'),
                selector: (row) => row?.voucherCode,
                style: tableStyle.columns.normal,
                sortable: false,
                width: '170px',
            },
            {
                id: 'DRIVER_NAME',
                name: UIHelper.buildTableColumn('Tên khách hàng'),
                minWidth: '270px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.driver?.fullname ?? ''}>
                            <span onClick={() => {
                                Utils.openInNewTab(`${AppRoute.customerList}/${row?.driver?.userId}`)
                            }} >{row?.driver?.fullname ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.link,
                sortable: false,
            },
            {
                id: 'VIN_NUMBER',
                name: UIHelper.buildTableColumn('Biển số xe'),
                width: '140px',
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.vehicle?.plate ?? ''}>
                            <span onClick={() => {
                                Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicle?.vehicleId}`)
                            }} >{row?.vehicle?.plate ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'VOUCHER_TYPE',
                name: UIHelper.buildTableColumn('Loại voucher'),
                width: '140px',
                selector: (row) => AgencyHelper.Utils.getVoucherTypeName(row?.type),
                style: tableStyle.columns.normal,
                sortable: false,
            },
            {
                id: 'VOUCHER_AMOUNT',
                name: UIHelper.buildTableColumn('Giá trị voucher'),
                selector: (row) => Utils.formatNumber(row.value ?? 0),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '140px',
                right: true,
            },
            {
                id: 'USED_AMOUNT',
                name: UIHelper.buildTableColumn('Giá trị đã sử dụng'),
                selector: (row) => Utils.formatNumber((row.value - row.remainValue) ?? 0),
                style: tableStyle.columns.normal,
                width: '170px',
                right: true,
            },
            {
                id: 'USED_QUANTITY',
                name: UIHelper.buildTableColumn('Số lần đã sử dụng'),
                selector: (row) => row?.usedCount,
                style: tableStyle.columns.normal,
                width: '170px',
                right: true,
            },
            {
                id: 'TRANSACTIONS',
                name: UIHelper.buildTableColumn('Phiên sạc sử dụng voucher'),
                selector: (row) => {
                    const transactionList = row?.transactions?.map(item =>
                        `CT${item?.transactionId?.toString().padStart(8, '0')}`
                    )?.join(', ');
                    return (
                        <KTTooltip
                            offset={[0, 0]}
                            text={transactionList || ''}
                        >
                            <span onClick={() => {
                                handleShowTransactionList(row?.transactions);
                            }}>
                                {transactionList || ''}
                            </span>
                        </KTTooltip>
                    )
                },
                style: tableStyle.columns.link,
                sortable: false,
                minWidth: '270px',
                omit: !adminRole,
            },
            {
                id: 'RELEASED_DATE',
                name: UIHelper.buildTableColumn('Ngày phát hành'),
                selector: (row) => row.releasedAt ? Utils.formatDateTimeToString(row.releasedAt, 'DD/MM/YYYY') : '',
                style: tableStyle.columns.normal,
                width: '130px',
            },
            {
                id: 'EXPIRED_DATE',
                name: UIHelper.buildTableColumn('Ngày hết hạn'),
                selector: (row) => row.expiredAt ? Utils.formatDateTimeToString(row.expiredAt, 'DD/MM/YYYY') : '',
                style: tableStyle.columns.normal,
                width: '130px',
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={AgencyHelper.Utils.getVoucherStatusName(row.status)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${AgencyHelper.Utils.getVoucherStatusColor(row.status)}`}
                        />
                    );
                },
                style: tableStyle.columns.normal,
                width: '150px',
            },
            // {
            //     id: 'CREATED_BY',
            //     name: UIHelper.buildTableColumn('Người tạo'),
            //     selector: (row) => {
            //         return (
            //             <KTTooltip offset={[0, 0]} text={row?.creator?.fullname}>
            //                 <span
            //                     className="cursor-pointer hover-opacity-60"
            //                     onClick={() => {
            //                         DealerHelper.navigateToParentAgency(row?.creator);
            //                     }}
            //                 >
            //                     {row?.creator?.fullname}
            //                 </span>
            //             </KTTooltip>
            //         );
            //     },
            //     style: tableStyle.columns.link,
            //     sortable: false,
            //     width: '200px',
            // },
            {
                id: 'DATE',
                name: UIHelper.buildTableColumn('Ngày tạo'),
                selector: (row) => Utils.formatDateTimeToString(row.createdAt, 'DD/MM/YYYY - HH:mm'),
                style: tableStyle.columns.normal,
                sortable: false,
                width: '160px',
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Xem chi tiết',
                                    click: () => {
                                        handleShowVoucherDetail(row);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-hand-holding-box"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Phát hành voucher',
                                    click: () => {
                                        handleReleaseVoucher(row);
                                    },
                                    show: row?.status === 'NEW'
                                    // && [AgencyConstants.VoucherBatchType.SELF_CLAIM, AgencyConstants.VoucherBatchType.INTERNAL].includes(row?.voucherBatch?.batchType),
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Ngừng hoạt động',
                                    click: () => handleSuspendVoucher(row),
                                    show: row?.status === 'VALID' || row?.status === 'NEW',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-play"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: 'Khôi phục hoạt động',
                                    click: () => handleActiveVoucher(row),
                                    show: row?.status === 'INVALID',
                                },
                            ]}
                        />
                    );
                },
            },
        ];
    }, [t, operatorList, user, filter, adminRole, voucherBatchId]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = router.pathname;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        saveChanges,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    useEffect(() => {
        if (showFullUI && !voucherBatchId) {
            setFilter(AgencyHelper.Filter.voucherList);
            setFilterDropdown(AgencyHelper.Filter.voucherList);
        } else {
            const updatedFilter = {
                q: '',
                page: 0,
                limit: AppConfigs.defaultPageLimit,
                voucherBatchId: '',
                status: '',
                releaseStatus: '',
                releasedDateFilter: dateFilter.tatCaThoiGian,
                releasedFrom: '',
                releasedTo: '',
                expiredDateFilter: dateFilter.tatCaThoiGian,
                expiredFrom: '',
                expiredTo: '',
            }
            setFilter(updatedFilter)
            setFilterDropdown(updatedFilter)
        }
    }, [showFullUI, voucherBatchId])

    useEffect(() => {
        getVoucherList(filter);
    }, [filter, refreshVoucherList]);

    const dropdownVoucherBatchEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="voucherBatchId"
                name="voucherBatchId"
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                        type="button"
                    >
                        {filter?.voucherBatchId ? `VP${filter?.voucherBatchId?.toString().padStart(8, '0')}` : 'Chọn lô voucher'}
                    </button>
                }
                selectedValue={selectedVoucherBatch}
                dropdownMenuItems={[{ name: 'Lô voucher', role: 'VOUCHER_BATCH' }]}
                getSubItems={async (item) => {
                    return AgencyHelper.API.requestGetVoucherBatchList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.voucherBatches?.map((row) => ({
                                id: row?.voucherBatchId,
                                name: `VP${row?.voucherBatchId?.toString().padStart(8, '0')}`,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedVoucherBatch(value);
                    updateFilter({
                        voucherBatchId: value?.id,
                        page: 0,
                    });
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                ignoreConfirmClick={true}
                defaultValue={{
                    name: 'Lô voucher',
                    role: 'VOUCHER_BATCH',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedVoucherBatch(null);
                            updateFilter({
                                voucherBatchId: '',
                                page: 0,
                            });
                        })}
                    </div>
                }
            />
        );
    }, [selectedVoucherBatch, filter]);

    // ---- methods ----
    const getVoucherList = (filter) => {
        setIsLoading(true);
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        if (voucherBatchId) {
            params.voucherBatchId = voucherBatchId;
        }
        if (agencyId) {
            params.agencyId = agencyId;
        }
        AgencyHelper.API.requestGetVoucherList(params)
            .then((response) => {
                setVoucherList(response?.vouchers);
                setTotal(response?.total);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const updateFilter = (changes) => {
        const updatedFilter = showFullUI && !voucherBatchId
            ? {
                ...AgencyHelper.Filter.voucherList,
                ...changes,
            }
            : {
                ...filter,
                ...changes,
            };

        if (showFullUI && !voucherBatchId) {
            AgencyHelper.Filter.voucherList = updatedFilter;
        }

        setFilter(updatedFilter);
        setFilterDropdown(updatedFilter);
    };

    const handleRefresh = () => {
        getVoucherList(filter);
    };

    const handleShowVoucherDetail = (row) => {
        AppCustomDialogHelper.show(
            'Chi tiết voucher',
            <AgencySaleDialogView
                confirmButtonText={null}
                cancelButtonText="Bỏ qua"
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onlyBodyEl={true}
                bodyEl={
                    <DialogVoucherDetailView
                        item={row}
                        user={user}
                        onCancel={() => {
                            AppCustomDialogHelper.hide();
                        }}
                        handleShowTransactionList={handleShowTransactionList}
                    />
                }
            />,
            'md',
            false,
            true
        );
    }

    // ngung hoat dong voucher
    const handleSuspendVoucher = (row) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogStopAgency} />}
                title="Ngừng hoạt động"
                contentEl={
                    <>
                        Bạn có chắc muốn ngừng hoạt động voucher{' '}
                        <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                            {`VC${row?.voucherId?.toString().padStart(8, '0')}`}
                        </span>{' '}
                        không?
                    </>
                }
                cancelButtonText="Bỏ qua"
                confirmButtonText="Ngừng hoạt động"
                confirmButtonRed={true}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                    AppCustomDialogHelper.hide();
                    const result = await AgencyHelper.API.requestUpdateVoucher(row?.voucherId, {
                        status: AgencyConstants.VoucherStatus.INVALID,
                    });
                    if (result && _.isBoolean(result)) {
                        ToastHelper.showSuccess('Ngừng hoạt động thành công');
                        handleRefresh();
                    } else {
                        ToastHelper.showError(result || 'Ngừng hoạt động thất bại');
                    }
                }}
            />,
            'md',
            true,
            true
        );
    }
    // khoi phuc hoat dong voucher
    const handleActiveVoucher = (row) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogActiveAgency} />}
                title="Khôi phục hoạt động"
                contentEl={
                    <>
                        Bạn có chắc muốn khôi phục hoạt động voucher{' '}
                        <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                            {row?.voucherId}
                        </span>{' '}
                        không?
                    </>
                }
                cancelButtonText="Bỏ qua"
                confirmButtonText="Khôi phục"
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async () => {
                    AppCustomDialogHelper.hide();
                    const result = await AgencyHelper.API.requestUpdateVoucher(row?.voucherId, {
                        status: row?.releasedAt ? AgencyConstants.VoucherStatus.VALID : AgencyConstants.VoucherStatus.NEW,
                    });
                    if (result && _.isBoolean(result)) {
                        ToastHelper.showSuccess('Khôi phục hoạt động thành công');
                        handleRefresh();
                    } else {
                        ToastHelper.showError(result || 'Khôi phục hoạt động thất bại');
                    }
                }}
            />,
            'md',
            true,
            true
        );
    }
    // phat hanh voucher
    const handleReleaseVoucher = (items) => {
        AppCustomDialogHelper.show(
            '',
            <DialogReleaseVoucherView
                items={items}
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    setReleaseVoucher([]);
                    handleRefresh();
                    getVoucherBatchDetail(voucherBatchId);
                }}
            />,
            'md',
            false,
            true
        );
    }

    // show danh sach phien sac su dung voucher
    const handleShowTransactionList = (transactions) => {
        AppCustomDialogHelper.show(
            'Phiên sạc sử dụng voucher',
            <div>
                <div className='p-4'>
                    <div style={{
                        border: `1px solid ${AppColors.gray[300]}`,
                        borderRadius: 10,
                        overflow: 'hidden',
                    }}>
                        <table className="w-100">
                            <thead>
                                <tr
                                    className="font-weight-bolder"
                                    style={{
                                        backgroundColor: '#F7F7FD',
                                        fontSize: Utils.returnFontSize(12),
                                        color: AppColors.gray[800],
                                    }}
                                >
                                    {['Phiên sạc', 'Thời gian'].map((header, index) => (
                                        <th
                                            key={index}
                                            className={`p-3 ${index === 0 ? 'text-left' : 'text-right'}`}
                                            style={{ minWidth: index === 0 ? '200px' : '150px' }}
                                        >
                                            {UIHelper.buildTableColumn(header)}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {transactions?.map((item, rowIndex) => (
                                    <tr
                                        key={item?.voucherTransactionId ?? rowIndex}
                                        style={{ borderTop: '1px solid #EBEDEF' }}
                                    >
                                        <td className="p-3 text-left">
                                            <span className='cursor-pointer'
                                                style={
                                                    UIHelper.buildFontStyle('700', '13px', AppColors.primary)
                                                }
                                                onClick={() => {
                                                    Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${item?.transactionId}`)
                                                }}>
                                                CT{item?.transactionId?.toString().padStart(8, '0')}
                                            </span>
                                        </td>

                                        <td className="p-3 text-right"
                                            style={
                                                UIHelper.buildFontStyle('500', '13px', AppColors.gray[700])
                                            }
                                        >
                                            {Utils.formatDateTimeToString(
                                                item?.createdAt,
                                                'DD/MM/YYYY - HH:mm'
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div
                    className="p-4 d-flex justify-content-end"
                    style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
                >
                    {UIHelper.buildNegativeButton(
                        'Đóng',
                        () => AppCustomDialogHelper.hide(),
                    )}
                </div>
            </div>,
            'md',
            true,
            true,
        );
    };

    // xuat file excel
    const handleExportExcel = async (exportData, params) => {
        let exportDataList = exportData;

        if (_.isEmpty(exportDataList)) {
            ToastHelper.showError('Không có dữ liệu để tải xuống');
            return;
        }

        const sheetFileName =
            'Danh_sách_voucher_' +
            moment(params.from).format('DDMMYYYY') +
            '_' +
            moment(params.to).format('DDMMYYYY');

        const ext = '.xlsx';
        const workbook = new ExcelJS.Workbook();

        const sheet = workbook.addWorksheet('Danh sách voucher', {
            headerFooter: { firstHeader: sheetFileName },
        });

        const lastColumn = adminRole ? 'O' : 'N';

        sheet.mergeCells(`A1:${lastColumn}1`);
        sheet.getCell('A1').value = `DANH SÁCH VOUCHER (NGÀY ${moment(
            params.from
        ).format('DD/MM/YYYY')} - ${moment(params.to).format('DD/MM/YYYY')})`;

        sheet.getCell('A1').font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
            color: { argb: 'FFFFFFFF' },
        };

        sheet.getCell('A1').alignment = {
            vertical: 'middle',
            horizontal: 'center',
        };

        sheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '29618E' },
            color: { argb: 'FFFFFF' },
        };

        sheet.getCell('A1').border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        sheet.getRow(1).height = 25;

        const columns = [
            { key: 'stt', width: 7 },
            { key: 'voucherCode', width: 15 },
            { key: 'batchCode', width: 15 },
            { key: 'useCode', width: 20 },
            { key: 'driverName', width: 30 },
            { key: 'vinNumber', width: 15 },
            { key: 'voucherType', width: 20 },
            { key: 'voucherAmount', width: 20 },
            { key: 'usedAmount', width: 20 },
            { key: 'usedQuantity', width: 20 },
            ...(adminRole ? [{ key: 'transactions', width: 30 }] : []),
            { key: 'releasedDate', width: 22 },
            { key: 'expiredDate', width: 22 },
            { key: 'status', width: 20 },
            // { key: 'createdBy', width: 22 },
            { key: 'date', width: 22 },
        ];

        sheet.columns = columns;

        sheet.getRow(2).height = 30;
        sheet.getRow(2).font = {
            name: 'Times New Roman',
            family: 4,
            size: 11,
            bold: true,
        };

        sheet.getRow(2).alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
        };

        const headers = [
            'STT',
            'Mã voucher',
            'Mã lô voucher',
            'Mã sử dụng',
            'Tên khách hàng',
            'Biển số xe',
            'Loại voucher',
            'Giá trị voucher',
            'Giá trị đã sử dụng',
            'Số lần đã sử dụng',
            ...(adminRole ? ['Phiên sạc sử dụng voucher'] : []),
            'Ngày phát hành',
            'Ngày hết hạn',
            'Trạng thái',
            // 'Người tạo',
            'Ngày tạo',
        ];

        headers.forEach((header, index) => {
            const cell = sheet.getCell(2, index + 1);

            cell.value = header;

            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        let i = 1;

        exportDataList?.forEach((row) => {
            const dataRow = sheet.addRow({
                stt: i++,
                voucherCode: row?.voucherId
                    ? `VC${row?.voucherId?.toString().padStart(8, '0')}`
                    : '',
                batchCode:
                    row?.voucherBatchCode ||
                    (row?.voucherBatchId
                        ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}`
                        : ''),
                useCode: row?.voucherCode,
                driverName: row?.driver?.fullname,
                vinNumber: row?.vehicle?.plate,
                voucherType: AgencyHelper.Utils.getVoucherTypeName(row?.type),
                voucherAmount: Utils.formatNumber(row?.value ?? 0),
                usedAmount: Utils.formatNumber(
                    (row?.value ?? 0) - (row?.remainValue ?? 0)
                ),
                usedQuantity: row?.usedCount,
                ...(adminRole && {
                    transactions: row?.transactions
                        ?.map(
                            (item) =>
                                `CT${item?.transactionId
                                    ?.toString()
                                    .padStart(8, '0')}`
                        )
                        ?.join(', '),
                }),
                releasedDate: row?.releasedAt
                    ? Utils.formatDateTimeToString(
                        row.releasedAt,
                        'DD/MM/YYYY'
                    )
                    : '',
                expiredDate: row?.expiredAt
                    ? Utils.formatDateTimeToString(
                        row.expiredAt,
                        'DD/MM/YYYY'
                    )
                    : '',
                status: AgencyHelper.Utils.getVoucherStatusName(row?.status),
                // createdBy: row?.creator?.fullname,
                date: row?.createdAt
                    ? Utils.formatDateTimeToString(
                        row.createdAt,
                        'DD/MM/YYYY - HH:mm'
                    )
                    : '',
            });

            dataRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };

                if (colNumber === 1) {
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'center',
                        wrapText: true,
                    };
                } else if (colNumber >= 8 && colNumber <= 10) {
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'right',
                        wrapText: true,
                    };
                } else {
                    cell.alignment = {
                        vertical: 'middle',
                        horizontal: 'left',
                        wrapText: true,
                    };
                }
            });
        });

        sheet.eachRow((row, rowNumber) => {
            if (rowNumber >= 3) {
                row.font = {
                    name: 'Times New Roman',
                    family: 4,
                    size: 11,
                    bold: false,
                };
            }
        });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);

            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = sheetFileName + ext;
            anchor.click();

            window.URL.revokeObjectURL(url);

            ToastHelper.showSuccess('Tải xuống file Excel thành công');
            AppCustomDialogHelper.hide();
        });
    };

    return (
        <div>
            {UIHelper.buildCard(
                <div className="pb-4">
                    {/* header */}
                    {showFullUI && (
                        <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    {!voucherBatchId ? ' Danh sách voucher' : ' Danh sách voucher thuộc lô'}
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng số:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                        {total != 0 ? total : voucherList?.length} voucher
                                    </span>
                                </span>
                            </div>
                            <div>
                                <div className="d-flex align-items-center justify-content-end gap-3 flex-wrap">
                                    {showFullUI && !voucherBatchId && UIHelper.buildBlueButton(
                                        'Tải xuống',
                                        async () => {
                                            try {
                                                ChargeHelper.UI.Excel.showDialogDownloadExcelFile(
                                                    AgencyHelper.Filter.voucherList,
                                                    async (params) => {
                                                        try {
                                                            const { vouchers = [] } = await AgencyHelper.API.requestGetVoucherList(params);
                                                            return handleExportExcel(vouchers, params);
                                                        } catch (error) {
                                                            ToastHelper.showError(`Lỗi khi lấy dữ liệu: ${error.message}`);
                                                            return [];
                                                        }
                                                    },
                                                );
                                            } catch (error) {
                                                ToastHelper.showError(`Lỗi khi khởi tạo tải xuống: ${error.message}`);
                                            }
                                        },
                                        <i className="fa-regular fa-download" />
                                    )}

                                    {adminRole && UIHelper.buildGreenButton(
                                        releaseVoucher?.length ? `Phát hành voucher (${String(releaseVoucher?.length || 0).padStart(2, '0')})` : 'Phát hành voucher',
                                        releaseVoucher?.length >= 2
                                            ? () => handleReleaseVoucher(releaseVoucher)
                                            : null,
                                        <i
                                            className="fa-regular fa-hand-holding-box"
                                            style={{ fontSize: 15 }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* table */}
                    <div className="">
                        {/* filter */}
                        <div className="row m-0 p-0 px-2">
                            {/* Tìm kiếm */}
                            <div className="col mb-4 px-2 pt-1">
                                {UIHelper.buildFormLabel("Tìm kiếm")}
                                <KTFormSearch
                                    name="search-bar"
                                    placeholder="Theo mã voucher, mã sử dụng"
                                    value={filter.q}
                                    onSubmit={(text) => {
                                        updateFilter({
                                            q: text,
                                            page: 0,
                                        });
                                    }}
                                />
                            </div>

                            {/* Mã lô voucher */}
                            {!voucherBatchId && (
                                <div className="col mb-4 px-2 pt-2">
                                    {UIHelper.buildTableColumn('Mã lô voucher')}
                                    {dropdownVoucherBatchEl}
                                </div>
                            )}

                            {/* Trạng thái voucher */}
                            <div className="col mb-4 px-2">
                                <KTDropdownFilter
                                    label="Trạng thái voucher"
                                    filterKey="status"
                                    options={[
                                        { name: "Tất cả", value: "" },
                                        ...AgencyHelper.Data.voucherStatusOptions,
                                    ]}
                                    selectedValue={filter.status}
                                    handleChange={(value) => {
                                        updateFilter({
                                            status: value,
                                            page: 0,
                                        });
                                    }}
                                />
                            </div>

                            {/* Trạng thái phát hành */}
                            <div className="col mb-4 px-2">
                                <KTDropdownFilter
                                    label="Trạng thái phát hành"
                                    filterKey="status"
                                    options={[
                                        { name: "Tất cả", value: "" },
                                        { name: "Đã phát hành", value: "VALID,INVALID,EXPIRED" },
                                        { name: "Chưa phát hành", value: "NEW,NEW" },
                                    ]}
                                    selectedValue={filter.status}
                                    handleChange={(value) => {
                                        updateFilter({
                                            status: value,
                                            page: 0,
                                        });
                                    }}
                                />
                            </div>

                            {/* Thời gian hết hạn */}
                            {!!voucherBatchId && (
                                <div className="col mb-4 px-2 pt-2">
                                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                                        Thời gian hết hạn
                                    </label>
                                    <CustomDateRangePicker2
                                        toggleElementBorderRadius={5}
                                        alignRight={true}
                                        initialValue={filter?.length > 0
                                            ? filter.expiredDateFilter
                                            : dateFilter.tatCaThoiGian
                                        }
                                        onPressSave={(selectedValue, startDate, endDate) => {
                                            updateFilter({
                                                expiredDateFilter: selectedValue,
                                                expiredFrom: startDate,
                                                expiredTo: endDate,
                                                page: 0,
                                            });
                                        }}
                                    />
                                </div>
                            )}

                            <div className="col mb-4 p-2 d-flex align-items-end gap-3">
                                {/* bo loc */}
                                <div style={{ minWidth: 95 }}>
                                    <ButtonFilterDropdown
                                        filtering={
                                            filter.q !== '' ||
                                            (!voucherBatchId
                                                ? filter.voucherBatchId !== ''
                                                : false) ||
                                            filter.status !== '' ||
                                            filter.releaseStatus !== '' ||
                                            filter.releasedDateFilter !== dateFilter.tatCaThoiGian ||
                                            filter.releasedFrom !== '' ||
                                            filter.releasedTo !== '' ||
                                            filter.expiredDateFilter !== dateFilter.tatCaThoiGian ||
                                            filter.expiredFrom !== '' ||
                                            filter.expiredTo !== ''

                                        }
                                        dropdownContent={
                                            <VoucherListFilterView
                                                filterDropdown={filterDropdown}
                                                selectedVoucherBatch={selectedVoucherBatch}
                                                setSelectedVoucherBatch={setSelectedVoucherBatch}
                                                setFilterDropdown={setFilterDropdown}
                                                showFullUI={showFullUI}
                                                setFilter={setFilter}
                                            // onCancel={() => {
                                            //     handleRefresh();
                                            // }}
                                            // onApply={() => {
                                            //     handleRefresh();
                                            // }}
                                            />
                                        }
                                    />
                                </div>
                                {/* Cấu hình cột */}
                                {!voucherBatchId && (
                                    <DropdownTableConfigColumn
                                        columnIds={columnIds}
                                        fullColumns={fullColumns}
                                        fullColumnIds={fullColumnsIdSorted}
                                        onChangeCheckboxValue={onChangeCheckboxValue}
                                        saveChanges={saveChanges}
                                        resetDefaultTableColumn={() => {
                                            setFullColumnIds(defaultColumnIds);
                                            resetDefaultTableColumn();
                                        }}
                                        onChangeFullColumnIds={(ids) => {
                                            setFullColumnIds(ids);
                                            const key = prefKey + "_FULL_COLUMN_IDS";
                                            localStorage.setItem(key, ids.join("|"));
                                        }}
                                        onSelectAll={onSelectAll}
                                        onUnSelectAll={onUnSelectAll}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="px-4">
                            <KTTable
                                idType='voucherId'
                                columns={columns}
                                items={voucherList}
                                selectableRows={adminRole && !agencyId}
                                selectableRowsNoSelectAll={false}
                                disabledItems={voucherList.filter(
                                    x => (x.status !== AgencyConstants.VoucherStatus.NEW ||
                                        ![AgencyConstants.VoucherBatchType.SELF_CLAIM, AgencyConstants.VoucherBatchType.INTERNAL].includes(x.voucherBatch.batchType) ||
                                        x.identityType !== AgencyConstants.VoucherIdentityType.ANY
                                    )
                                )}
                                preselectedItems={voucherList.filter(item =>
                                    releaseVoucher.includes(item.voucherId)
                                )}
                                striped={false}
                                compactGrid={false}
                                onClickedRow={(row) => { }}
                                onSelectedRowsChanged={(selectedRows) => {
                                    const newSelectedIds = selectedRows.map(row => row.voucherId);

                                    if (JSON.stringify(newSelectedIds.sort()) !== JSON.stringify(releaseVoucher.sort())) {
                                        setReleaseVoucher(newSelectedIds);
                                    }
                                }}
                                onDoubleClickedRow={(row) => { }}
                                noDataComponent={
                                    <EmptyView
                                        icon={imgEmptyNoData}
                                        title="Không có dữ liệu để hiển thị"
                                        text={
                                            <span>
                                                Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                            </span>
                                        }
                                    />
                                }
                            />
                        </div>
                    </div>

                    {/* pagination */}
                    <div className="px-4 mt-2">
                        <KTPagination
                            currentPage={filter?.page + 1}
                            rowCount={total != 0 ? total : voucherList?.length}
                            rowsPerPage={filter?.limit}
                            currentItemInPageCount={voucherList?.length}
                            onChangePage={(newPage) => {
                                updateFilter({
                                    page: parseInt(newPage) - 1,
                                });
                            }}
                            onChangeRowsPerPage={(newRowsPerPage) => {
                                updateFilter({
                                    limit: parseInt(newRowsPerPage),
                                    page: 0,
                                });
                            }}
                            loading={isLoading}
                            color={KTPaginationColor.success}
                            appendText="voucher"
                        />
                    </div>
                </div>,
                false,
                !showFullUI
            )}
        </div>
    );
}

export default VoucherListView;
